import { DependenciesInjection } from "app/di/DependencyInjection";
import { AirTimeManagementImpl } from "features/airTimeManagement/data/AirtimeManagementImpl";
import { IAirTimeManagementRepository } from "features/airTimeManagement/domain/repositories/IAirtimeManagementRepository";
import { AirtimeManagementUseCase } from "features/airTimeManagement/domain/useCases/AirtimeManagementUseCase";
import { AirTimeManagementViewModel } from "features/airTimeManagement/presentation/viewModel/AirTimeManagementViewModel";
import { AirtimeManagementToken } from "./AirtimeManagementToken";

export class AirtimeManagementInjection {
  static injectAirtimeManagement() {
    DependenciesInjection.register<IAirTimeManagementRepository>(
      AirtimeManagementToken.IAirTimeManagementRepository,
      AirTimeManagementImpl,
      "otherRepo",
    );
    DependenciesInjection.register<AirtimeManagementUseCase>(
      AirtimeManagementToken.AirtimeManagementUseCase,
      AirtimeManagementUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<AirTimeManagementViewModel>(
      AirtimeManagementToken.AirTimeManagementViewModel,
      AirTimeManagementViewModel,
      "viewModel",
    );
  }

  static getAirtimeManagementRepo() {
    return DependenciesInjection.getRepo<IAirTimeManagementRepository>(
      AirtimeManagementToken.IAirTimeManagementRepository,
    );
  }

  static getAirtimeManagementUseCase() {
    return DependenciesInjection.getRepo<AirtimeManagementUseCase>(
      AirtimeManagementToken.AirtimeManagementUseCase,
    );
  }
}
